import React from 'react';
import dayjs from 'dayjs';

export function getFormType() {
  const t = window.location.hash || '';
  if (t.includes('innovate')) {
    return 'innovate';
  }
  if (t.includes('scientist')) {
    return 'scientist';
  }
  return 'innovate';
}

export function getPopContainer() {
  return document.querySelector('.body .cont .apply') || document.body;
}

export function getBirthByIdCard(idCard) {
  const year = idCard.substring(6, 10);
  const month = idCard.substring(10, 12);
  const day = idCard.substring(12, 14);
  return `${year}-${month}-${day}`;
}

export const cellRender = (time, date) => {
  const curDate = dayjs().format('YYYY-MM-DD');
  if (date.format('YYYY-MM-DD') === curDate) {
    return <a>至今</a>;
  }
  return <a>{time}</a>;
};

export const valueRangeRender = (value) => {
  const newValue = ['', ''];
  const [startTime, endTime] = value;
  newValue[0] = startTime;
  if (endTime === dayjs().format('YYYY-MM-DD')) {
    newValue[1] = '至今';
  } else {
    newValue[1] = endTime;
  }
  return newValue;
};
